// extracted by mini-css-extract-plugin
var _1 = "ni3Zmtd7";
var _2 = "ni3Zmtd7";
export { _1 as "video-embed", _2 as "videoEmbed" }
